module.exports = __webpack_public_path__ + "static/media/1.13c7242f.jpg";